import { TypePickingRoute } from '../../interfaces/PickingRoute/TypePickingRoute'
import { TypePickingRouteAction } from '../actions/typePickingRouteActions'
import { GET_TYPE_PICKING_ROUTE_EXITO } from '../types/typePickingRouteActionsTypes'

export interface TypePickingRouteState {
  typesPickingRouteState: {
    typesPickingRoute?: TypePickingRoute[]
    error?: string | undefined
  }
}

const initialState: TypePickingRouteState = {
  typesPickingRouteState: { typesPickingRoute: [], error: '' }
}

export const typePickingRouteReducer = (
  state: TypePickingRouteState = initialState,
  action: TypePickingRouteAction
): TypePickingRouteState => {
  if (action.type === GET_TYPE_PICKING_ROUTE_EXITO) {
    return {
      ...state,
      typesPickingRouteState: {
        typesPickingRoute: action.typesPickingRoute,
        error: action.error
      }
    }
  }
  return state
}
